import { Component } from "@angular/core";

import { BaseControlComponent } from "../../../../../../form-controls/components/base-control/base-control.component";
import { ContextInteractionService } from "../../../../../../form-controls/services/context-interaction.service";


@Component({
    selector: "app-pdf-generator-display-config",
    templateUrl: "pdf-generator-display-config.component.html",
    standalone: false
})
export class PdfGeneratorDisplayConfigComponent extends BaseControlComponent {
    static componentName = "PdfGeneratorDisplayConfigComponent";

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }


}